import Vue from 'vue'
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VueFilter from 'vue-filter';
import VueValidator from 'vue-validator';

import Config from '../config/config';
import { configRouter } from './routes.js';

// Bootstrap 4
require('bootstrap/dist/js/bootstrap.js');
require('eonasdan-bootstrap-datetimepicker');

// install filters
Vue.use(VueFilter);

// Custom Filter
Vue.filter('filename', function (value) {
  return value.split(/(\\|\/)/g).pop()
});

// install validators
Vue.use(VueValidator);

// Custom email validator
Vue.validator('email', function (val) {
  return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
});

// install vue-resource
Vue.use(VueResource);
Vue.http.options.root = Config.API_ROOT;
Vue.http.options.emulateJSON = true;

// install router
Vue.use(VueRouter);

// create router
const router = new VueRouter({
  history: true,
  saveScrollPosition: true
});

// configure router
configRouter(router);

// bootstrap the app
router.start(require('./App.vue'), 'app');



// WEBPACK FOOTER //
// ./src/main.js